import api from './utilPartner';

const controller = 'PessoaFuncionario';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarPorPessoa: function (dto) {
    return api.Axios.GetParams(url, dto);
  },
  Desvincular: function (id) {
    return api.Axios.Delete(url, id);
  }
});
